import { useEffect } from 'react';
import { useReveal } from '../components/useReveal';
import { SITE } from '../data/site';
import './ContentPage.css';

export function AboutPage() {
  useReveal('about');
  useEffect(() => {
    document.title = `About — ${SITE.name}`;
  }, []);

  return (
    <article className="page">
      <div className="page__glow" aria-hidden="true" />
      <header className="page__head shell">
        <p className="eyebrow">Est. 1984</p>
        <h1 className="page__title">The arcade that never closed.</h1>
        <p className="page__lede">
          {SITE.name} is a fictional 1984 arcade, lovingly rebuilt in full 3D — a whole cabinet of
          original games dressed in neon, scanlines, and a sunset that never sets.
        </p>
      </header>

      <div className="page__body shell reveal">
        <p>
          The conceit is simple: somewhere in 1984, ARCADIA AMUSEMENTS INC. opened its doors. It
          never shut them. Each cartridge is a love letter to the games we grew up on — the racers,
          shooters, climbers, and crossings of the coin-op golden age — reimagined for this world and
          rebuilt with modern 3D rendering the hardware of the era could only dream about. No licensed
          properties, no trademarked names; the homage is the whole point.
        </p>
        <p>
          We built {SITE.name} to be the opposite of a launcher bloated with pop-ups. It&rsquo;s a
          Progressive Web App: it loads in a browser, installs to your home screen if you want it
          there, and plays instantly. No store gatekeeper, no multi-gigabyte download, no waiting.
        </p>

        <div className="stat-row">
          <div className="stat">
            <span className="stat__num">{SITE.gameCount}</span>
            <span className="stat__label">original cartridges</span>
          </div>
          <div className="stat">
            <span className="stat__num">3D</span>
            <span className="stat__label">remastered, every one</span>
          </div>
          <div className="stat">
            <span className="stat__num">0</span>
            <span className="stat__label">downloads required</span>
          </div>
        </div>

        <h2 className="page__h2">Made by {SITE.studio}</h2>
        <p>
          {SITE.name} is built by{' '}
          <a href={SITE.studioUrl} target="_blank" rel="noreferrer">
            {SITE.studio}
          </a>
          , a small studio of{' '}
          <a href={SITE.legalEntityUrl} target="_blank" rel="noreferrer">
            {SITE.legalEntity}
          </a>{' '}
          that makes browser-native games and platforms. We care about games that boot fast, run everywhere, and
          respect your attention — and your privacy. The arcade keeps its telemetry in our own
          database, not a third-party analytics service; it runs no third-party ad SDKs.
        </p>

        <h2 className="page__h2">Free to start</h2>
        <p>
          Try a demo of any game with no account at all. Sign in and you get daily play tokens; when
          you want the whole cabinet wide open, a Day, Week, or Month Pass unlocks unlimited plays.
          No tokens to hoard, no cooldowns to wait out.
        </p>

        <div className="page__cta">
          <a className="btn" href={SITE.appUrl}>
            ENTER THE ARCADE &#9656;
          </a>
          <a className="btn btn--ghost" href="/contact">
            GET IN TOUCH
          </a>
        </div>
      </div>
    </article>
  );
}
